import { render, staticRenderFns } from "./examinee.vue?vue&type=template&id=05605e36&scoped=true&"
import script from "./examinee.vue?vue&type=script&lang=js&"
export * from "./examinee.vue?vue&type=script&lang=js&"
import style0 from "./examinee.vue?vue&type=style&index=0&id=05605e36&lang=less&scoped=true&"
import style1 from "./examinee.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05605e36",
  null
  
)

export default component.exports